import { useState, useEffect } from "react";
import { HiMenu, HiX } from "react-icons/hi";

const OtherHeader = ({ isOpen, setIsOpen, cookie }) => {
  const [activePath, setActivePath] = useState(window.location.pathname);

  useEffect(() => {
    const handleRouteChange = () => setActivePath(window.location.pathname);
    window.addEventListener("popstate", handleRouteChange);
    return () => window.removeEventListener("popstate", handleRouteChange);
  }, []);

  const navItems = ["Home", "FAQs", "Contact Us"];

  return (
    <div className="">
      <nav className="px-6 max-w-[1280px] mx-auto w-full ">
        <div className="bg-white h-[1px] w-full relative top-[0px]"></div>

        <div className="flex justify-between items-center">
     
        <a href={cookie ? `/?cid=${cookie}` : "/"}>
            <img src="/white-logo.png" alt="Park Plus Logo" className="h-[70px] md:h-[131px] md:w-[228px] w-auto my-2" />
          </a>

          <button
            className="md:hidden text-2xl text-gray-700"
            onClick={() => setIsOpen(!isOpen)}
          >
            {isOpen ? <HiX className="text-primary" /> : <HiMenu className="text-primary" />}
          </button>

 
          <div className="hidden md:flex flex-[0.3] justify-between space-x-6 text-white mt-[3px]">
            {navItems.map((item, index) => {
              const path = item === "Home" ? "/" : `/${item.toLowerCase().replace(/\s+/g, "-")}`;
              const url = cookie ? `${path}?cid=${cookie}` : path; 
              return (
                <a
                  key={index}
                  href={url}
                  className={`font-normal hover:bg-[#7d92f1] hover:border-b-2 hover:border-white h-[100px] px-2 py-1 flex justify-center items-center relative top-[-25px] ${
                    activePath === url ? "text-white border-b-2 border-white bg-[#7d92f1]" : ""
                  }`}
                  onClick={() => setActivePath(url)}
                >
                  {item}
                </a>
              );
            })}
          </div>
        </div>

        {/* Mobile Dropdown */}
        {isOpen && (
          <div className="md:hidden my-4 bg-white shadow-lg rounded-md p-3 ">
            {navItems.map((item, index) => {
              const path = item === "Home" ? "/" : `/${item.toLowerCase().replace(/\s+/g, "-")}`;
              const url = cookie ? `${path}?cid=${cookie}` : path; 
              return (
                <a
                  key={index}
                  href={url}
                  className={`block text-black py-2 font-medium hover:text-black ${
                    activePath === url ? "text-primary font-bold" : ""
                  }`}
                  onClick={() => {
                    setIsOpen(false);
                    setActivePath(url);
                  }}
                >
                  {item}
                </a>
              );
            })}
          </div>
        )}
      </nav>
    </div>
  );
};

export default OtherHeader;